/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Otomatik_OnaylamaInputs */

const tr_faq_a_otomatik_onaylama = /** @type {(inputs: Faq_A_Otomatik_OnaylamaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otomasyonlar sayfasına gidip Sipariş Senkronizasyonu kartındaki Otomatik Onayla seçeneğini aktif edebilirsin. Etkinleştirdiğinde gelen siparişler belirli koşulları (stok yeterliliği, fiyat uygunluğu) karşılıyorsa senin onayın beklenmeden otomatik işleme alınır. Hangi pazaryerlerinde geçerli olacağını seçerek ayarlayabilirsin.`)
};

const en_faq_a_otomatik_onaylama = /** @type {(inputs: Faq_A_Otomatik_OnaylamaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Automations and enable the Auto-Approve option on the Order Sync card. Orders that meet your conditions (stock available, price valid) are processed automatically. You choose which platforms it applies to.`)
};

const de_faq_a_otomatik_onaylama = /** @type {(inputs: Faq_A_Otomatik_OnaylamaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehe zu Automatisierungen und aktiviere die Option Auto-Genehmigung auf der Karte Bestellsynchronisierung. Bestellungen, die deine Bedingungen erfüllen, werden automatisch verarbeitet.`)
};

const ru_faq_a_otomatik_onaylama = /** @type {(inputs: Faq_A_Otomatik_OnaylamaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейдите в Автоматизации и включите опцию Авто-одобрение на карточке синхронизации заказов. Заказы, соответствующие вашим условиям, будут обрабатываться автоматически.`)
};

/**
* | output |
* | --- |
* | "Go to Automations and enable the Auto-Approve option on the Order Sync card. Orders that meet your conditions (stock available, price valid) are processed au..." |
*
* @param {Faq_A_Otomatik_OnaylamaInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_otomatik_onaylama = /** @type {((inputs?: Faq_A_Otomatik_OnaylamaInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Otomatik_OnaylamaInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_otomatik_onaylama(inputs)
	if (locale === "de") return de_faq_a_otomatik_onaylama(inputs)
	if (locale === "ru") return ru_faq_a_otomatik_onaylama(inputs)
	return tr_faq_a_otomatik_onaylama(inputs)
});